/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-param-reassign */
import React, { useCallback, useEffect, useMemo, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useLocation } from 'react-router-dom';
import Axios from 'axios';
import { toast } from 'react-toastify';
import { Icon } from '@iconify/react';
import { Box, ThemeProvider, createMuiTheme } from '@material-ui/core';
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineSeparator
} from '@material-ui/lab';
import mdClose from '@iconify/icons-ion/md-close';
import moment from 'utils/moment';
import Loading from '../../../../../components/loading';
import Modal from '../../../../../components/modal';
import Detail from '../../../../../components/DetailPageBuilder/Detail';
import styles from '../../../../../components/DetailPageBuilder/detail.module.scss';
import { changeCurrentPage } from '../../../../../general_redux/actions';
import { fetchspecificAdpLogs, clearState, clearDetailsState, getAdpDefaultFields,
  clearPaymentState, getAdpCategories } from '../../../redux/action';
import { getApiBaseUrl } from '../../../../../constants/apiEnv';
import Button from '../../../../../components/button/button';
import { renderInfoForType, showCustomTable } from '../../../../../utils/helpers';
import { getFeeWithInvoice } from '../../../components/ActionCompo';
import TnsPaymentModal from '../../MyApplications/components/TnsPaymentModal';


const DetailPage = (props) => {
  const dispatch = useDispatch();
  const baseURL = getApiBaseUrl() ? getApiBaseUrl() : 'https://api.web.com/api';
  const jwtToken = localStorage.getItem('token');
  const hasSentTrackingRef = useRef(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const PaymentStatus = params.get('CheckPayment');
  const headers = {
    'Content-Type': 'application/json',
    Authorization: jwtToken
  };
  const profile = useSelector(states => states.auth.profile);
  const log = useSelector(states => states?.permitManagement?.specificLog);
  const settings = useSelector(states => states?.permitManagement?.adpSettings);
  const adp_defaultFields = useSelector(states => states?.permitManagement?.adpDSchema);
  const adpSchemaSettings = useSelector(state => state.permitManagement?.adpSchemaSettings);
  const adpCategories = useSelector(state => state?.permitManagement?.adpCategories);
  const feeTypesList = useSelector(state => state?.permitManagement?.adpFeeWithCategoriesList);
  const adp_customFields = useSelector(states => states?.permitManagement?.adpCSchema);
  const paymentActionStatus = useSelector(states => states?.permitManagement?.makeAdpPaymentAction);
  const getADPdetailsStatus = useSelector(states => states?.permitManagement?.getADPdetailsStatus);
  const paymentRedirectUrl = useSelector(states => states?.permitManagement?.paymentRedirectUrl);
  const adpPaymentDetail = useSelector(states => states?.permitManagement?.adpPaymentDetail);
  const adp_order = useSelector(states => states?.permitManagement?.adpOrder);
  const logId = props?.match?.params?.id;
  const TodayDate = moment(new Date());
  const adpSchema = useSelector(states => states?.permitManagement?.adpSchema);
  const customField = useSelector(state => state.permitManagement?.AdpCSchema);
  const oldCustomFields = useSelector(data => data?.permitManagement?.adpCSchema);
  const renewal_data = { adpSchema, customField, oldCustomFields };
  const tableHeaders = [
    ['comment', 'comment'],
    ['created_at', 'Applied On'],
    ['application_type', 'Application Type'],
    ['first_name', 'First name'],
    ['last_name', 'Last Name'],
    ['email', 'Email'],
    ['phone', 'Phone'],
    ['company', 'Company'],
    ['employee_id', 'Employee Id'],
    ['designation', 'Designation'],
    ['issusing_authority', 'Issusing Authority'],
    ['driving_lic_num', 'License Number'],
    ['lic_issue_date', 'License Issue date'],
    ['lic_exp_date', 'License Expiration Date'],
    ['type_of_lic', 'License Type'],
    ['permit_type', 'Permit Type'],
    ['renewal_date', `${profile.permit_management?.renewal || 'Renewal'} Date`],
    ['category_of_adp', 'Category Of Adp'],
    ['dob', 'Date Of Birth'],
    ['signature', 'Signature']
  ];
  const firstHeaders = [
    ['comment', 'Comment'],
    ['application_type', 'Application Type'],
    ['created_at', 'Applied On'],
    ['badge_no', `${profile.permit_management?.badge || 'Badge'} Number`],
    ['renewal_date', `${profile.permit_management?.renewal || 'Renewal'} Date`]
  ];
  const lastHeaders = [
    ['submitted_by', 'Initiated By']
  ];
  const defaultIDs = useMemo(() => ([
    'first_name', 'last_name', 'email', 'phone', 'designation', 'company', 'driving_lic_num', 'type_of_lic', 'dob',
    'issusing_authority', 'employee_id', 'lic_issue_date', 'lic_exp_date', 'permit_type', 'category_of_adp', 'signature'
  ]), []);
  const [historyModal, setHistoryModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [tnsPaymentModal, setTnsPaymentModal] = useState(false);
  const [isRejected, setIsRejected] = useState(false);
  const [violationsHistory, setViolationsHistory] = useState([]);
  const [loader, setLoader] = useState(false);

  const Theme = useMemo(() => createMuiTheme({
    overrides: {
      MuiTimeline: {
        root: {
          padding: 0
        }
      },

      MuiTimelineItem: {
        missingOppositeContent: {
          '&:before': {
            display: 'none'
          }
        }
      },

      MuiTimelineDot: {
        defaultPrimary: {
          backgroundColor: '#A6E50F',
          margin: 0
        },
        defaultSecondary: {
          backgroundColor: '#3A61A8',
          margin: 0
        }
      },

      MuiTimelineConnector: {
        root: {
          width: '1px',
          background: '#DBE4F0 0% 0% no-repeat padding-box',
          backgroundColor: '#DBE4F0',
          opacity: 1
        }
      },

      MuiTimelineContent: {
        root: {
          padding: '6px 10px'
        }
      }
    }
  }), []);

  if (log.settings?.enable_quantum_points_adp) {
    lastHeaders.push(
      ['quantum_points', 'Quantum Points']
    );
  }

  const handelHistory = () => {
    setLoader(true);
    Axios.get(`${baseURL}/app/violations/driver_permit/${logId}/violations_history`, { headers })
    .then((res) => {
      setViolationsHistory(res.data|| []);
      setLoader(false);
    })
    .catch(() => {
      setLoader(false);
      toast.error('Please try again later');
    });
    setHistoryModal(!historyModal);
  };

  const handleComments = () => {
    setCommentModal(true);
  };

  const handleGetLatestADPDetails = useCallback(
    () => dispatch(fetchspecificAdpLogs(logId)),
    [dispatch, logId]
  );

  const allAdpFields = useMemo(() => {
    if (!adp_defaultFields?.length) return [];
    const allFields = [...adp_defaultFields, ...adp_customFields].map(f => ({
      ...f,
      values: f.values ? f.values.map(v => ({ ...v })) : f.values,
      conditional_values: f.conditional_values ? f.conditional_values.map(v => ({ ...v })) : f.conditional_values
    }));

    allFields.forEach((eachItem) => {
      if (defaultIDs.includes(eachItem.id) && eachItem.type === 'select') {
        if (eachItem && eachItem.values) {
          eachItem.values.forEach((v) => {
            if (v.key?.toString() !== v.value?.toString()) v.key = v.value;
          });
        }
        if (eachItem && eachItem.conditional_values) {
          eachItem.conditional_values.forEach((v) => {
            if (v.label?.toString() !== v.value?.toString()) v.label = v.value;
          });
        }
      }
    });
    return allFields;
  }, [adp_defaultFields, adp_customFields, defaultIDs]);

  useEffect(() => {
    dispatch(clearState());
    dispatch(fetchspecificAdpLogs(logId, PaymentStatus));
    dispatch(getAdpDefaultFields());
    dispatch(getAdpCategories(true));
    dispatch(getAdpCategories(false, false, false, profile?.current_tenant?.id));
    dispatch(changeCurrentPage(profile?.permit_management?.driver_permit || 'ADP'));
  }, [dispatch]);
  useEffect(() => {
    if (log?.latest_payment_response?.status && getADPdetailsStatus?.success && !hasSentTrackingRef?.current) {
      hasSentTrackingRef.current = true;
      setTnsPaymentModal(true);
    }
  }, [getADPdetailsStatus?.success, log?.latest_payment_response?.status]);

  useEffect(() => () => {
    dispatch(clearDetailsState());
  }, [dispatch]);

  useEffect(() => {
    setIsRejected(
      Object.keys(log?.additional_info || {})?.includes('rejected_documents')
      && Object.keys(log?.additional_info?.rejected_documents || {})?.length > 0
    );
  }, [log?.additional_info]);

  useEffect(() => {
    if (paymentActionStatus?.success) {
      if (!paymentRedirectUrl) toast.success(adpPaymentDetail || 'Payment Successful');
      dispatch(clearPaymentState());
      dispatch(fetchspecificAdpLogs(logId));
    }
    if (paymentActionStatus?.error) {
      toast.error('Error occurred while processing payment');
      dispatch(clearPaymentState());
    }
  }, [paymentActionStatus?.success, paymentActionStatus?.error, dispatch, logId]);

  const handleRemoveParams = () => {
    const url = new URL(window.location.href);
    url.searchParams.delete('CheckPayment');
    window.history.replaceState({}, document.title, url.pathname);
  };

  const getDescription = () => {
    const applicationFeeTypes = settings?.application_based_fee_types || [];
    const currentFeeType = applicationFeeTypes.find(feeType => feeType.key === log?.payment_stage);
    return currentFeeType?.name || '';
  };

  const buildInvoiceData = (payment, currencyType) => ({
    invoiceColumns: [
      { label: 'Description', key: 'feeCategoryName' },
      { label: 'Quantity', key: 'quantity' },
      { label: 'Unit Price (excl. VAT)', key: 'baseFeeWithoutTax' },
      { label: 'VAT Percentage', key: 'taxRate' },
      { label: 'Amount (incl. VAT)', key: 'totalFeeWithTax' }
    ],
    columnData: payment?.other_info?.invoiceObject?.map(eachObj => ({
      ...eachObj,
      quantity: 1,
      baseFeeWithoutTax: `${currencyType} ${Number(eachObj?.baseFeeWithoutTax)?.toFixed(2)}`,
      taxRate: eachObj?.taxAmount ? `${Number(eachObj?.taxRate)?.toFixed(2)} %` : '0.00 %',
      totalFeeWithTax: `${currencyType} ${Number(eachObj?.totalFeeWithTax)?.toFixed(2)}`
    })) || [],
    tblRow: { fontSize: '20px' },
    tblData: { fontSize: '20px' }
  });

  // attach invoice details for each payment
  if (log?.settings?.custom_invoice_template) {
    log.showCustomTable = showCustomTable;

    const fullAddress = Array.isArray(log?.company_address)
      && log?.company_address?.map(a => [a.street, a.city, a.state, a.zip]
      .filter(Boolean).join(', ')).join(' | ');

    log.invoicesByFeeType = log?.work_flow?.payments?.map(payment => ({
      ...payment,
      invoiceData: buildInvoiceData(payment, payment?.other_info?.currency),
      invoiceDate: renderInfoForType({ type: 'datetime' }, payment?.payment_date),
      companyAddress: fullAddress
    }));
  }

  const selectedCategory = adpCategories?.find(c => ((c.name === log?.category_of_adp) && (c.id === log?.adp_category)));

  const rePrintList = (feeTypesList?.filter(item => (
    item?.category?.name?.toLowerCase() === selectedCategory?.name?.toLowerCase()
      && item?.name === 'on_reprint_application'
    ))
    .map(item => item?.fee_category) || []);
  const invoiceObject = getFeeWithInvoice({
    description: getDescription(),
    feeCategoryData: feeTypesList,
    taxData: adpSchemaSettings?.tax_details,
    applicationType: log?.application_type,
    applicationFor: log?.payment_stage || (log?.status !== 3 && 'on_application_submission'),
    selectedCategory: selectedCategory?.name,
    isVatApplicable: adpSchemaSettings?.isVatApplicable,
    feeCategory: log?.additional_info?.reprint_info?.feeDetails || null
  }) || {};

  const getCancellationValue = getFeeWithInvoice({
    description: getDescription(),
    feeCategoryData: feeTypesList,
    taxData: adpSchemaSettings?.tax_details,
    applicationType: log?.application_type,
    applicationFor: 'on_cancel_or_rejection',
    selectedCategory: selectedCategory?.name,
    isVatApplicable: false
  }) || {};

  const hasOfflinePayment = adpSchemaSettings?.adp_payment_type_for_tenant === 'offline';

  return <>
    {log && (
    <Detail backRoute={props?.location?.state?.myApplication ? '/adp/myapplications' : '/adp/logs'}
      logData={log} firstHeaders={firstHeaders} lastHeaders={lastHeaders} tableHeaders={tableHeaders}
      panelname={profile?.permit_management?.driver_permit || 'ADP'} {...props} actionsBtn
      adpDetails
      adpHistory={`${profile?.permit_management?.violations || 'Violtaions'} History`}
      adpComments={`${profile?.permit_management?.comments || 'Comments'}`}
      isRejected={isRejected}
      handleComments={handleComments}
      handelHistory={handelHistory}
      cancellationFee={getCancellationValue}
      invoiceObject={invoiceObject}
      paymentByTenant={adpSchemaSettings?.charge_fees_per_adp_permit}
      hasOfflinePayment={hasOfflinePayment}
      handleGetLatestADPDetails={handleGetLatestADPDetails}
      defaultIDs={defaultIDs}
      allFields={allAdpFields}
      order={adp_order}
      settings={settings}
      category={log?.category_of_adp}
      logId={logId}
      rePrintList={rePrintList}
      renewal_data={renewal_data}
      tnsPaymentModal={tnsPaymentModal}
    />
    )}
    {tnsPaymentModal && (
      <TnsPaymentModal
        tnsPaymentModal={tnsPaymentModal}
        onClosePaymentModal={() => {
          setTnsPaymentModal(false);
          handleRemoveParams();
        }}
        tnsPaymentMessages
        tnsPaymentResponse={log?.latest_payment_response}
      />
    )}
    <Modal
      onClose={() => setCommentModal(false)}
      showIn={commentModal}
      width="864px"
      minHeight="50%"
    >
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        className={styles.headerBox}
      >
        <div className={styles.commentsHeader}>
          <div className={styles.title}>
            <FormattedMessage
              id=" "
              defaultMessage={'Rejected Documents'}
              values={{ id: 27 }}
            />
          </div>
        </div>
        <div className={styles.iconGroup}>
          <Icon
            icon={mdClose}
            onClick={() => setCommentModal(false)}
            height="20"
            style={{ cursor: 'pointer' }}
          />
        </div>
      </Box>
      <div className={styles.timelineContainer}>
        <ThemeProvider theme={Theme}>
          {Object.values(log?.additional_info?.rejected_documents || {})?.map(each => (
            <Timeline key={each.document_name}>
              <TimelineItem align="left">
                <TimelineSeparator>
                  <TimelineDot color={'primary'} />
                  <TimelineConnector />
                </TimelineSeparator>
                <TimelineContent>
                  <div
                    className={styles.timelineItemContent}
                  >
                    <p className={styles.commentValue}>
                      <b>Document Name: </b>
                      <span>{each?.document_name || '-'}</span>
                    </p>
                    <p className={styles.commentValue}>
                      <b>Rejected On: </b>
                      <span>
                        {renderInfoForType({ 'type': 'datetime' }, each?.document_verified_on, null, null)}
                      </span>
                    </p>
                    <p className={styles.commentTitle}>
                      <b>Comments: </b>
                      <span>{each?.comment || '-'}</span>
                    </p>
                  </div>
                </TimelineContent>
              </TimelineItem>
            </Timeline>
          ))}
        </ThemeProvider>
      </div>

      <div className={styles.closeBtn}>
        <Button
          action={'tertiary'}
          onClick={() => setCommentModal(false)}
          translationID={'assets.modal.close'}
          defaultText={'Close'}
        />
      </div>
    </Modal>
      <Modal
          onClose={() => setHistoryModal(false)}
          showIn={historyModal}
          width="80%"
          minHeight="70%"
        >
          <Loading loadingStatus={loader} />
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            className={styles.headerBox}
          >
            <div className={styles.commentsHeader}>
              <div className={styles.title}>
                <FormattedMessage
                  id=" "
                  defaultMessage={`${profile?.permit_management?.violations || 'Violation'} History`}
                  values={{ id: 27 }}
                />
              </div>
            </div>
            <div className={styles.iconGroup}>
              <Icon
                icon={mdClose}
                onClick={() => {
                  setHistoryModal(!historyModal);
                }}
                height="20"
                style={{ cursor: 'pointer' }}
              />
            </div>
          </Box>
          <div className={styles.history}>
                {violationsHistory && violationsHistory?.length
                ? <table style={{ width: '100%' }}>
                    <thead>
                      <tr className={styles.table_heading}>
                        <th style={{ minWidth: '13%' }}>{profile.permit_management?.badge || 'Badge'} Number</th>
                        <th style={{ minWidth: '11%', marginRight: '15px' }}>Type</th>
                        <th style={{ minWidth: '10%', marginRight: '20px' }}>Offence</th>
                        <th style={{ minWidth: '13%', marginRight: '5px' }}>Description</th>
                        <th style={{ minWidth: '10%' }}>{profile?.permit_management?.violations || 'Violation'} Date</th>
                        <th style={{ minWidth: '8%' }}>Points</th>
                        <th style={{ minWidth: '11%' }}>Expiry Date</th>
                        <th style={{ minWidth: '12%' }}>Warning/Penalty</th>
                        <th style={{ minWidth: '10%' }}>Status</th>
                      </tr>
                      <hr />
                    </thead>
                    <tbody>
                    { violationsHistory.map(item => (
                      <><tr className={styles.table_data}>
                        <td style={{ minWidth: '13%' }}>{item?.permit_no
                        || item?.permit_management_driverpermit?.badge_no}
                        </td>
                        <td style={{ minWidth: '11%', marginRight: '15px' }}>{item?.type}</td>
                        <td style={{ minWidth: '10%', marginRight: '20px' }}>{item?.sub_type || ''}</td>
                        <td style={{ minWidth: '13%', marginRight: '5px' }}>{item?.violation_details}</td>
                        <td style={{ minWidth: '10%' }}>{moment(item?.violation_at).format(localStorage?.getItem('dateFormat') || 'MM/DD/YYYY')}</td>
                        <td style={{ minWidth: '8%' }}>{item?.points}</td>
                        <td style={{ minWidth: '11%' }}>{item?.valid_until && moment(item?.valid_until).format(localStorage?.getItem('dateFormat')
                        || 'MM/DD/YYYY')}
                        </td>
                        <td style={{ minWidth: '12%' }}>{item.warning_only? 'Warning': 'Penalty'}</td>
                        <td style={{ minWidth: '10%' }}>{TodayDate >= moment(item?.valid_until)
                        ? <div style={{ color: 'grey' }}> Inactive</div> : <div style={{ color: '#3A61A8' }}>Active</div>}
                        </td>
                        </tr>
                        <hr />
                      </>
                      ))}
                    </tbody>
                  </table>
                   : <div className={styles.no_history}>
                   <span>
                      No History Found
                   </span>
                     </div>
                }
          </div>
      </Modal>
         </>;
};
export default DetailPage;
